<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      max-width="490"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <span @click="open" v-bind="attrs" v-on="on">{{ roundingNumber(item[header]) }}</span>
      </template>
      <v-card>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <span class="font-weight-bold">Розробка:</span>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemDev.estimateMinDev"
                  :focus="editItemDev.focusedEl === 'estimateMin' ? true : false"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateDevError
                      ? setErrorMessagesDev('estimateMinDev')
                      : []
                  "
                  :hide-details="false"
                  label="min"
                  suffix="годин"
                  @input="
                    checkEstimateDevInputsFilled();
                    $v.editItemDev.estimateMinDev.$touch();
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemDev.estimateNormDev"
                  :focus="editItemDev.focusedEl === 'estimateNorm' ? true : false"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateDevError
                      ? setErrorMessagesDev('estimateNormDev')
                      : []
                  "
                  :hide-details="false"
                  label="norm"
                  suffix="годин"
                  @input="
                    checkEstimateDevInputsFilled();
                    $v.editItemDev.estimateNormDev.$touch();
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemDev.estimateMaxDev"
                  :focus="editItemDev.focusedEl === 'estimateMax' ? true : false"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateDevError
                      ? setErrorMessagesDev('estimateNormDev')
                      : []
                  "
                  :hide-details="false"
                  label="max"
                  suffix="годин"
                  @input="
                    checkEstimateDevInputsFilled();
                    $v.editItemDev.estimateNormDev.$touch();
                  "
                />
              </v-col>
            </v-row>
            <!-- analytics -->
            <span class="font-weight-bold">Аналітика:</span>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemAnalyst.estimateMinAnalyst"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateAnalystError
                      ? setErrorMessagesAnalyst('estimateMinAnalyst')
                      : []
                  "
                  :hide-details="false"
                  label="min"
                  suffix="годин"
                  @input="
                    checkEstimateAnalystInputsFilled();
                    $v.editItemAnalyst.estimateMinAnalyst.$touch();
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemAnalyst.estimateNormAnalyst"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateAnalystError
                      ? setErrorMessagesAnalyst('estimateNormAnalyst')
                      : []
                  "
                  :hide-details="false"
                  label="norm"
                  suffix="годин"
                  @input="
                    checkEstimateAnalystInputsFilled();
                    $v.editItemAnalyst.estimateNormAnalyst.$touch();
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <DecimalEditor
                  v-model="editItemAnalyst.estimateMaxAnalyst"
                  :scale="1"
                  :outlined="false"
                  :error-messages="
                    showEstimateAnalystError
                      ? setErrorMessagesAnalyst('estimateNormAnalyst')
                      : []
                  "
                  :hide-details="false"
                  label="max"
                  suffix="годин"
                  @input="
                    checkEstimateAnalystInputsFilled();
                    $v.editItemAnalyst.estimateNormAnalyst.$touch();
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <p>
                <b>* min</b> - мінімальний час виконання завдання.
                <br>
                <i class="caption"
                  >Оцінка при відсутності перешкод та додаткових умов
                </i>
                <br>
                <b>* norm</b> – нормальний час виконання завдання.
                <br>
                <i class="caption">
                  Стільки згідно зі статистикою зазвичай виконуються аналогічні
                  завдання, після уточнень і доповнень
                </i>
                <br>
                <b>* max</b> – максимальний час виконання завдання.
                <br>
                <i class="caption">Можливий час в разі непередбачених перешкод і додаткових
                  умов, ймовірність такої ситуації зустрічається рідко, але такі
                  ризики є
                </i>
              </p>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn color="red lighten-2" text @click="validateEstimate()">
            Зберегти
          </v-btn>
          <v-btn color="grey" text @click="close">
            Відмінити
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import DecimalEditor from "../../../components/DecimalEditor.vue";
import { required } from "vuelidate/lib/validators";
export default {
  components: { DecimalEditor },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    header: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    editItemDev: null,
    editItemAnalyst: null,
    showEstimateDevError: false,
    showEstimateAnalystError: false,
    menu: false,
  }),
  validations() {
    return {
      editItemDev: {
        estimateMinDev: {
          required,
          minValue: (value) => 0 < value,
          maxValue: (value) => value < Number(this.editItemDev.estimateNormDev),
        },
        estimateNormDev: {
          required,
          minValue: (value) => Number(this.editItemDev.estimateMinDev) < value,
          maxValue: (value) => value < Number(this.editItemDev.estimateMaxDev),
        },
      },
      editItemAnalyst: {
        estimateMinAnalyst: {
          required,
          minValue: (value) => 0 < value,
          maxValue: (value) => value < Number(this.editItemAnalyst.estimateNormAnalyst),
        },
        estimateNormAnalyst: {
          required,
          minValue: (value) => Number(this.editItemAnalyst.estimateMinAnalyst) < value,
          maxValue: (value) => value < Number(this.editItemAnalyst.estimateMaxAnalyst),
        },
      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.editItemDev = {
          estimateMinDev: val.estimateMinDev,
          estimateNormDev: val.estimateNormDev,
          estimateMaxDev: val.estimateMaxDev,
        };
        this.editItemAnalyst = {
          estimateMinAnalyst: val.estimateMinAnalyst,
          estimateNormAnalyst: val.estimateNormAnalyst,
          estimateMaxAnalyst: val.estimateMaxAnalyst,
        };
      },
      immediate: true,
    },
  },
  computed: {
    errors() {
      return {
        NUMBER: {
          minValue: ["Значення має бути більше 0"],
          maxValue: ["Неправильне значення оцінки"],
        },
      };
    },
  },
  methods: {
    validateEstimate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showEstimateDevError = true;
        this.showEstimateAnalystError = true;
      }
      this.showEstimateDevError = false;
      this.showEstimateAnalystError = false;
      const newEstimate = {
        id: this.item.id,
        estimate: {
          minDev: this.roundingNumber(this.editItemDev.estimateMinDev),
          avgDev: this.roundingNumber(this.editItemDev.estimateNormDev),
          maxDev: this.roundingNumber(this.editItemDev.estimateMaxDev),
          minAnalyst: this.roundingNumber(
            this.editItemAnalyst.estimateMinAnalyst
          ),
          avgAnalyst: this.roundingNumber(
            this.editItemAnalyst.estimateNormAnalyst
          ),
          maxAnalyst: this.roundingNumber(
            this.editItemAnalyst.estimateMaxAnalyst
          ),
        },
      };
      this.$emit("update", newEstimate);
      this.close();
    },
    setErrorMessagesAnalyst(inputName) {
      if (!this.$v.editItemAnalyst[inputName].maxValue) {
        return this.errors.NUMBER.maxValue;
      }
      if (!this.$v.editItemAnalyst[inputName].minValue) {
        return this.errors.NUMBER.minValue;
      }
      return [];
    },
    setErrorMessagesDev(inputName) {
      if (!this.$v.editItemDev[inputName].maxValue) {
        return this.errors.NUMBER.maxValue;
      }
      if (!this.$v.editItemDev[inputName].minValue) {
        return this.errors.NUMBER.minValue;
      }
      return [];
    },
    open() {
      this.editItemDev.focusedEl = `${this.header}Dev`;
      this.menu = true;
    },
    close() {
      this.menu = false;
      this.showEstimateDevError = false;
      this.showEstimateAnalystError = false;
      this.editItemDev = {};
      this.editItemAnalyst = {};
    },
    checkEstimateDevInputsFilled() {
      if (
        !this.editItemDev.estimateMinDev ||
        !this.editItemDev.estimateNormDev ||
        !this.editItemDev.estimateMaxDev
      ) {
        return;
      }

      if (
        this.$v.editItemDev.estimateMinDev?.$invalid ||
        this.$v.editItemDev.estimateNormDev?.$invalid ||
        this.$v.editItemDev.estimateMaxDev?.$invalid
      ) {
        this.showEstimateDevError = true;
      } else {
        return false;
      }
    },
    checkEstimateAnalystInputsFilled() {
      if (
        !this.editItemAnalyst.estimateMinAnalyst ||
        !this.editItemAnalyst.estimateNormAnalyst ||
        !this.editItemAnalyst.estimateMaxAnalyst
      ) {
        return;
      }

      if (
        this.$v.editItemAnalyst.estimateMinAnalyst?.$invalid ||
        this.$v.editItemAnalyst.estimateNormAnalyst?.$invalid ||
        this.$v.editItemAnalyst.estimateMaxAnalyst?.$invalid
      ) {
        this.showEstimateAnalystError = true;
      } else {
        return false;
      }
    },
    roundingNumber(num) {
      return parseFloat(parseFloat(num).toFixed(1));
    },
  },
};
</script>
